// Integrations shown on the Integrations page. A new one needs its module-flag DefaultSetting, a CONSTANTS_SETTINGS
// entry, an entry here, and for a settings tab a SETTING_GROUP_IDS + INTEGRATION_TABS + SETTINGS_TAB_ICONS entry.

import { SETTING_GROUP_IDS } from './settingsMenuConfig';
import { CONSTANTS_SETTINGS } from './settingsContainer';
import {
	LogoControlApp,
	LogoInceptionApp,
	LogoIntegrityApp,
	LogoMicrosoft365App,
	LogoShellyApp,
	LogoTTLockApp,
	LogoVerkadaApp,
	LogoVortexApp
} from 'assets/images/svg/Logos';

/**
 * @typedef {Object} IntegrationConfig
 * @property {string|number} key           - SettingGroup ID (also the selectedSettingGroupID when clicked)
 * @property {string}        label         - Display name
 * @property {string}        category      - Short kind shown under the name
 * @property {string}        description   - Card pitch
 * @property {string}        logo          - Image asset
 * @property {number}        moduleFlag    - DefaultSettingID of the module toggle
 * @property {string}       [featureFlag]  - optional feature-flag code; the card is hidden until the org is entitled
 */

/** @type {IntegrationConfig[]} */
export const INTEGRATIONS = [
	{
		key: SETTING_GROUP_IDS.CONTROL,
		label: 'Zezamii Locks',
		category: 'Smart locks',
		description: 'Sync your Zezamii locks, cards and passcodes.',
		logo: <LogoControlApp />,
		moduleFlag: CONSTANTS_SETTINGS.CONTROL_MODULE
	},
	{
		key: SETTING_GROUP_IDS.INNER_RANGE,
		label: 'Integriti',
		category: 'Access control by Inner Range',
		description: 'Sync doors, users and credentials with Integriti.',
		logo: <LogoIntegrityApp />,
		moduleFlag: CONSTANTS_SETTINGS.INNER_RANGE_MODULE
	},
	{
		key: SETTING_GROUP_IDS.TTLOCK,
		label: 'TTLock',
		category: 'Smart locks',
		description: 'Sync your TTLock locks, eKeys, passcodes and cards.',
		logo: <LogoTTLockApp />,
		moduleFlag: CONSTANTS_SETTINGS.TTLOCK_MODULE
	},
	{
		key: SETTING_GROUP_IDS.VERKADA,
		label: 'Verkada',
		category: 'Cameras',
		description: 'Bring your Verkada cameras into Zezamii.',
		logo: <LogoVerkadaApp />,
		moduleFlag: CONSTANTS_SETTINGS.VERKADA_MODULE
	},
	{
		key: SETTING_GROUP_IDS.INCEPTION,
		label: 'Inception',
		category: 'Access control by Inner Range',
		description: 'Sync doors, areas and access groups with Inception.',
		logo: <LogoInceptionApp />,
		moduleFlag: CONSTANTS_SETTINGS.INCEPTION_MODULE
	},
	{
		key: SETTING_GROUP_IDS.VORTEX,
		label: 'VORTEX',
		category: 'Cameras by VIVOTEK',
		description: 'Bring your VORTEX cameras and NVR channels into Zezamii.',
		logo: <LogoVortexApp />,
		moduleFlag: CONSTANTS_SETTINGS.VORTEX_MODULE
	},
	{
		key: SETTING_GROUP_IDS.MICROSOFT_365,
		label: 'Microsoft 365',
		category: 'Calendars',
		description: 'Mirror approved room bookings into Outlook calendars.',
		logo: <LogoMicrosoft365App />,
		moduleFlag: CONSTANTS_SETTINGS.M365_MODULE,
		// Gated by the m365Bookings feature flag (see IntegrationsPage); hidden for non-entitled orgs.
		featureFlag: 'm365Bookings'
	},
	{
		key: SETTING_GROUP_IDS.SHELLY,
		label: 'Shelly',
		category: 'Presence sensors',
		description: 'Live room occupancy from Shelly Presence sensors.',
		logo: <LogoShellyApp />,
		moduleFlag: CONSTANTS_SETTINGS.SHELLY_MODULE,
		// Ships dark behind the `presence` feature flag (see IntegrationsPage).
		featureFlag: 'presence'
	}
];

// Integrations can all be off simultaneously — Access still works with
// Zezamii-native devices. No minimum.
export const MIN_ACTIVE_INTEGRATIONS = 0;
